<template>
  <div
    style="border: 0px solid black; width:100%;"
    v-if="has_perm('view_advertise') || GET_ACCOUNT_DATA.id == 1"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-primary">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <label for="name">{{
                $t("sidebar.advertise.advertiselist")
              }}</label>
              <div>
                <lte-button
                  style="float:right;background-color:white !important; margin-right: 50px"
                  type="btn btn-default"
                  right_icon="fa fa-plus"
                  @click="addnew"
                  v-if="
                    has_perm('create_advertise') || GET_ACCOUNT_DATA.id == 1
                  "
                >
                  {{ $t("advertise.addnew") }}
                </lte-button>
              </div>
            </div>
          </div>
          <div class="box-body">
            <div>
              <b-table
                :per-page="perPage"
                :current-page="currentPage"
                striped
                hover
                :fields="fields"
                :items="avertiseinfo"
              >
                <template slot="actions" slot-scope="row">
                  <div class="btn-group">
                    <button
                      @click="onhandleEdit(row)"
                      class="btn btn-primary"
                      v-if="
                        has_perm('update_advertise') || GET_ACCOUNT_DATA.id == 1
                      "
                      style="margin-left: 6px"
                    >
                      <i class="glyphicon glyphicon-edit"></i>
                    </button>
                    <button
                      @click="onhandleDelete(row)"
                      v-if="
                        has_perm('delete_advertise') || GET_ACCOUNT_DATA.id == 1
                      "
                      class="btn btn-danger"
                      style="margin-left: 6px"
                    >
                      <i class="glyphicon glyphicon-trash"></i>
                    </button>
                  </div>
                </template>
              </b-table>
              <!-- b pagina -->
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="right"
                size="sm"
                class="mt-0"
              ></b-pagination>
              <!-- end pagi -->
            </div>
            <!-- Modal Confirm Delete -->
            <div class="modal fade" :ref="`modal-pkg-tp`">
              <div class="modal-dialog">
                <confirm :id="pkg_tp_data.id" @confirm="onDeleteConfirm" />
              </div>
            </div>

            <loading
              :active.sync="isLoading"
              :can-cancel="false"
              color="#1E90FF"
            ></loading>

            <!-- snackbar -->
            <lte-core-alert
              v-for="snackbar in GET_SNACK_BAR"
              :key="snackbar.id"
              :item="snackbar"
            ></lte-core-alert>
            <!-- /.modal-dialog -->
          </div>
        </div>
      </row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import LTEButton from "@/components/LTEButton.vue";
import Confirm from "@/components/Confirm.vue";
import loading from "vue-loading-overlay";
import utils from "@/lib/utils";

export default {
  name: "AdvertiseList",
  data() {
    return {
      avertiseinfo: [],
      currentPage: 1,
      totalRows: 1,
      isLoading: false,
      perPage: 50,
      pkg_tp_data: {
        id: 0
      },
      fields: [
        {
          key: "STT",
          label: "STT",
          class: "text-center",
          tdClass: "stt"
        },
        {
          key: "name",
          label: this.$t("advertise.name"),
          class: "text-center"
        },
        {
          key: "date_created",
          label: this.$t("advertise.date_created"),
          class: "text-center"
        },
        {
          key: "active",
          label: this.$t("advertise.active"),
          class: "text-center"
        },
        {
          key: "actions",
          label: this.$t("advertise.action"),
          class: "actions_style"
        }
      ]
    };
  },
  watch: {
    GET_ADVERTISE_LIST: function() {
      this.avertiseinfo = [];
      this.GET_ADVERTISE_LIST.forEach((ad, idx) => {
        let data = {
          STT: idx + 1,
          name: ad.name,
          id: ad.id,
          date_created: utils.formatSqlDate(ad.date_created, null, "DD-MM-YYYY"),
          active: ad.active
        };
        this.avertiseinfo.push(data);
      });
      this.totalRows = this.avertiseinfo.length;
      this.isLoading = false;
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ADVERTISE_LIST",
      "PAGINATION",
      "GET_ACCOUNT_DATA",
      "PAGINATOR",
      "PAGE_ARROW"
    ])
  },
  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "GET_ADVERTISE_DATA",
      "DELETE_ADVERTISE",
      "ON_SHOW_TOAST",

      "SUCCESS_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onhandleDelete: function(row) {
      this.pkg_tp_data.id = row.item.id;
      this.onToggleDeleteConfirm();
    },
    onToggleDeleteConfirm: function(action = "show") {
      $(this.$refs[`modal-pkg-tp`]).modal(action);
    },
    onDeleteConfirm: function(id) {
      const payload = {
        id: id
      };
      this.isLoading = true;
      this.DELETE_ADVERTISE(payload)
        .then(
          function() {
            let currentPage = this.PAGINATION.page;
            let totalPage = this.PAGINATOR.length;
            let page =
              currentPage >= totalPage && this.templateEmaillist == 1
                ? totalPage >= 2
                  ? totalPage - 1
                  : 1
                : currentPage;
            const data = {
              params: {
                page: page
              }
            };
            this.GET_ADVERTISE_DATA(data);
            this.isLoading = false;
            $(this.$refs[`modal-pkg-tp`]).modal("hide");
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
            $(this.$refs[`modal-pkg-tp`]).modal("hide");
          }.bind(this)
        );
    },
    onhandleEdit: function(row) {
      let id = row.item.id;
      this.$router.push({
        name: "AdvertiseAdd",
        params: {
          id: id
        }
      });
    },
    addnew() {
      this.$router.push({
        name: "AdvertiseAdd",
        params: {
          id: 0
        }
      });
    }
  },
  mounted() {
    const data = {
      params: {
        page: 1
      }
    };
    this.GET_ADVERTISE_DATA(data);
  },
  components: {
    confirm: Confirm,
    "lte-core-alert": LTECoreAlert,
    "lte-button": LTEButton,
    loading: loading
  }
};
</script>

<style>
.actions_style {
  display: flex;
  justify-content: flex-end;
  margin-right: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Advertise/AdvertiseList.vue